import axios from 'axios';

class EventPing {
    start(eventId) {
        this.eventId = eventId
        setInterval(this.intervalHandler.bind(this), 10000);
    }

    intervalHandler() {
        axios.get(`/eventi/${this.eventId}/ping`)
    }
}

export default EventPing;
